<template>
  <div class="audio-wrap B_C11">
    <lottie
      :options="defaultOptions"
      :height="160"
      v-bind:class="{lottiestyle : true, mask: !isPermission}"
      :width="505"
      v-on:animCreated="handleAnimation"
    />
    <div class="cover-wrap" v-if="!isPermission">
      <div class="lock-icon"></div>
      <div class="subscribe-btn S8 T5" @click="emitBuy">立即订阅</div>
      <div class="subscribe-font S4 T1">订阅后点击播放语音</div>
    </div>
    <video-player
      v-if="isPermission"
      :play-info="playInfo"
      video-height="480px"
      @pause="pause()"
      @play="play()"
      @ended="ended()"
    ></video-player>
  </div>
</template>
<script>
import animationData from '../../lottie/voice-bar.json'
import lottie from 'vue-lottie'
import VideoPlayer from '@/components/VideoPlayer'
export default {
  components: {
    lottie,
    VideoPlayer
  },
  props: ['playInfo', 'isPermission'],
  data() {
    return {
      defaultOptions: { animationData: animationData },
      animationSpeed: 1,
      anim: {},
      isPlay: false,
      currentTime: '00:00',
      totalTime: ''
    }
  },
  watch: {},
  created() {},
  methods: {
    handleAnimation(anim) {
      this.anim = anim
      this.anim.pause()
    },
    pause() {
      this.anim.pause()
    },
    play() {
      this.anim.play()
    },
    ended: function () {
      this.anim.stop()
    },
    getTimeFun() {
      var audio = document.getElementById('mp3Btn')
      this.currentTime = this.transTime(audio.currentTime)
      this.totalTime = this.transTime(audio.duration)
      const processWidth = audio.currentTime / audio.duration
      document.getElementById('progress').style.width = processWidth * 100 + '%'
      document.getElementById('dot').style.left = processWidth * 100 + '%'
      if (this.currentTime >= this.totalTime) {
        this.isPlay = false
        document.getElementById('progress').style.width = 0
        document.getElementById('dot').style.left = 0
      }
    },
    transTime(time) {
      const duration = parseInt(time)
      let minute = parseInt(duration / 60)
      let sec = (duration % 60) + ''
      const isM0 = ':'
      if (minute === 0) {
        minute = '00'
      } else if (minute < 10) {
        minute = '0' + minute
      }
      if (sec.length === 1) {
        sec = '0' + sec
      }
      return minute + isM0 + sec
    },
    drawFun() {
      setTimeout(() => {
        var audio = document.getElementById('mp3Btn')
        var oDiv1 = document.getElementById('box')
        var oDiv2 = document.getElementById('progress')
        var oDiv3 = document.getElementById('dot')
        oDiv3.addEventListener(
          'touchstart',
          ev => {
            audio.pause()
            var oDiv1W = oDiv1.offsetWidth
            var oldX = ev.targetTouches[0].clientX - oDiv3.offsetLeft
            oDiv3.addEventListener('touchmove', fnMove, false)
            oDiv3.addEventListener('touchend', fnEnd, false)

            function fnMove(ev) {
              var x = ev.targetTouches[0].clientX - oldX
              if (x >= oDiv1W) {
                x = oDiv1W
              } else if (x <= 0) {
                x = 0
              }
              oDiv3.style.left = x + 'px'
              oDiv2.style.width = x + 'px'
            }
            function fnEnd() {
              oDiv3.removeEventListener('touchend', fnEnd, false)
              oDiv3.removeEventListener('touchmove', fnMove, false)
              var oDiv2W = oDiv2.offsetWidth
              var oDuration = oDiv2W / oDiv1W
              audio.play()

              audio.currentTime = oDuration * audio.duration
            }
          },
          false
        )
      }, 20)
    },
    emitBuy() {
      this.$emit('goBuy')
    }
  }
}
</script>
<style lang="scss" scoped>
.mask {
  opacity: 0.5;
}
.lottiestyle {
  left: 160px;
  position: absolute;
  bottom: 150px;
}
.totle {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 1px;
  color: #ffffff;
}

.audio-wrap {
  min-width: 828px;
  min-height: 466px;
  position: relative;
  border-radius: 10px;
  background-color: #deecf7;
  .cover-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 388px;
    border-radius: 10px;
    text-align: center;
    .lock-icon {
      width: 92px;
      height: 92px;
      background: url('./images/lock.png') no-repeat;
      background-size: cover;
      margin: 78px auto 0;
    }
    .subscribe-btn {
      width: 180px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 30px auto;
      background-color: #ddbc65;
      border-radius: 5px;
      cursor: pointer;
    }

    .subscribe-font {
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 58px;
      letter-spacing: 0px;
      color: #858585;
    }
  }
  .bottom-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #000000;
    opacity: 0.5;
  }
  .progress-wrap {
    position: relative;
    flex: 1;
    // width: 506px;
    height: 3px;
    margin: 20px;
    background: #dddddd;
    border-radius: 1px;
    .progress {
      position: absolute;
      left: 0;
      right: 0;
      height: 3px;
      width: 0;
      border-radius: 1px;
      background-color: #2e7ff2;
    }
    // .dot {
    //   width: 64px;
    //   height: 64px;
    //   position: absolute;
    //   left: 0;
    //   top: -28px;
    //   // background-color: #2e7ff2;
    //   .dot-style {
    //     width: 13px;
    //     height: 13px;
    //     border-radius: 50%;
    //     position: absolute;
    //     left: 0;
    //     top: 24px;
    //     // margin: 0;
    //     background-color: #2e7ff2;
    //   }
    // }
    .dot {
      width: 13px;
      height: 13px;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: -5px;
      background-color: #2e7ff2;
      :after {
        content: '';
        position: absolute;
        left: -20px;
        top: -20px;
        right: -20px;
        bottom: -20px;
      }
    }
  }
  .time-wrap {
    display: flex;
    justify-content: space-between;
    color: #2e7ff2;
    font-size: 12px;
    line-height: 12px;
    margin-top: 20px;
  }
  // .time-wrap {
  //   position: absolute;
  //   bottom: 9px;
  //   right: 10px;
  //   width: 120px;
  //   height: 36px;
  //   background-color: rgba($color: #000000, $alpha: 0.5);
  //   border-radius: 18px;
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   .icon {
  //     width: 20px;
  //     height: 20px;
  //     background: url('./images/time.png') no-repeat;
  //     background-size: cover;
  //     margin: 0 8px 0 0;
  //   }
  // }
  .play {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 92px;
    height: 92px;
    background: url('./images/play.png') no-repeat;
    background-size: cover;
    &.pause {
      background-image: url('./images/pause.png');
    }
  }
}
</style>
